import { ScheduleActivityMajorMilestoneBase } from './base/schedule-activity-major-milestone-base';

export class ScheduleActivityMajorMilestone extends ScheduleActivityMajorMilestoneBase { }